export default __webpack_public_path__ + "static/media/cancel-icon.3112b2ef.svg";